module.exports = __webpack_public_path__ + "static/media/bnmshop.c0746d93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/decoration/img/bnmshop.jpg
// module id = 742
// module chunks = 0